var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_vm._v(" Oeltima Experimental © Copyright 2023 "),_c('a',{attrs:{"href":"https://oeltimacreation.com","target":"_blank"}},[_vm._v("oeltimacreation.com")])])
}]

export { render, staticRenderFns }